import type { QueryClient } from '@tanstack/react-query';
import { queryRoleKey } from '@/utils/apiRole';
import { appointmentKeys } from './keys';

/**
 * Invalidates appointment stats and list caches after mutations.
 *
 * @param queryClient - React Query client instance
 * @param role - Current user role
 * @param selectedClientId - Admin-selected client ID
 * @param selectedCompanyId - Admin-selected company ID
 */
export function invalidateAppointmentQueries(
  queryClient: QueryClient,
  role: string | undefined,
  selectedClientId?: string | null,
  selectedCompanyId?: string | null
): void {
  const roleKey = queryRoleKey(role, selectedClientId, selectedCompanyId);
  void queryClient.invalidateQueries({ queryKey: appointmentKeys.statsForRole(roleKey) });
  void queryClient.invalidateQueries({ queryKey: appointmentKeys.listsForRole(roleKey) });
  void queryClient.invalidateQueries({ queryKey: appointmentKeys.listsExternalForRole(roleKey) });
}
